/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Typography } from '@coursera/cds-core';

import { Section } from 'bundles/enterprise-admin-user-filters/components/ui';
import { Spacer } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-user-filters';

const ZeroState: React.VFC<{ onSelectPrimaryFilter: () => void }> = ({ onSelectPrimaryFilter }) => {
  return (
    <Section isZeroState>
      <Typography variant="h2semibold" component="h2">
        {_t('How do you want to filter learners?')}
      </Typography>
      <Spacer size={16} />
      <Button size="small" onClick={onSelectPrimaryFilter} data-testid="add-primary-filter">
        {_t('Select your primary filter')}
      </Button>
    </Section>
  );
};

export default ZeroState;
